<template>
  <div class="serviceHome">
    <div class="he20"></div>
    <div class="serviceTitle">
      <p>磁罗经技术服务部上海分部</p>
      <div class="serviceHomeline"></div>
    </div>
    <div class="he50"></div>
    <div class="serviceBox">
      <div class="left">
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon1" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系人</div>
            <div class="text">许凯音</div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon2" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系邮箱</div>
            <div class="text">810872132@qq.com</div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon1" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系地址</div>
            <div class="text">
              上海市虹口区高阳路
              <br />147号405室
            </div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon4" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系电话</div>
            <div class="text">
              65967017
              <br />15601619621
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="../../../assets/img/branch/bg.png" alt />
      </div>
    </div>
    <div class="he50"></div>
    <div class="linedashed"></div>
    <div class="he50"></div>
    <div class="serviceHeard">上海分部校正人员信息</div>
    <div class="servicebody">
      <span>陈炳坤</span>
      <span>陈军伟</span>
      <span>陈震</span>
      <span>程杰</span>
      <span>曹炯</span>
      <span>丁兆刚</span>
      <span>范顺军</span>
      <span>付贵生</span>
      <span>顾霄罗</span>
      <span>韩威</span>
      <span>胡海云</span>
      <span>胡建</span>
      <span>黄辰烨</span>
      <span>李坚光</span>
      <span>李金龙</span>
      <span>李骏</span>
      <span>李宁</span>
      <span>李寅捷</span>
      <span>梁国飞</span>
      <span>刘建东</span>
      <span>刘剑峰</span>
      <span>刘炜晨</span>
      <span>陆诚佳</span>
      <span>彭火根</span>
      <span>戚骏琪</span>
      <span>亓先军</span>
      <span>钱立胜</span>
      <span>钱晓华</span>
      <span>秦 臻</span>
      <span>庆所</span>
      <span>沈浦根</span>
      <span>沈翔宇</span>
      <span>沈湧涛</span>
      <span>苏孝红</span>
      <span>汤坤荣</span>
      <span>陶益飞</span>
      <span>仝坤</span>
      <span>王明栋</span>
      <span>王彦仕</span>
      <span>王智</span>
      <span>吴志宾</span>
      <span>吴忠</span>
      <span>谢小龙</span>
      <span>辛迪帆</span>
      <span>徐磊鉴</span>
      <span>徐生浪</span>
      <span>徐晓光</span>
      <span>羊锐锐</span>
      <span>杨凡</span>
      <span>杨忠伟</span>
      <span>殷家华</span>
      <span>尤光荣</span>
      <span>曾华</span>
      <span>张小辉</span>
      <span>张哲军</span>
      <span>赵志强</span>
      <span>周睿</span>
      <span>周夏</span>
      <span>周毅平</span>
      <span>周跃明</span>
      <span>朱艺立</span>
    </div>
    <div class="he20"></div>
  </div>
</template>

<script>
import icon1 from "@/assets/img/branch/item1.png";
import icon2 from "@/assets/img/branch/item2.png";
import icon4 from "@/assets/img/branch/item4.png";
export default {
  data() {
    return {
      img: {
        icon1,
        icon2,
        icon4
      }
    };
  },
  methods: {
    softwhy() {
      var Url2 = window.location.href;
      var oInput = document.createElement("input");
      oInput.value = Url2;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
    }
  }
};
</script>

<style lang="less">
.serviceHome {
  .serviceTitle {
    padding: 0 10px;
    font-size: 24px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    line-height: 48px;
  }
  .serviceHomeline {
    margin-top: 10px;
    width: 90px;
    height: 4px;
    background: rgba(108, 44, 102, 1);
    // border: 1px dashed;;
  }
  .linedashed {
    border: 1px dashed rgba(191, 195, 199, 1);
  }
  .serviceBox {
    // display: flex;
    // justify-content: space-between;
    .left {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        width: 100%;
        .itemRight {
          margin-left: 20px;
          .titel {
            font-size: 22px;
            font-weight: bold;
            color: rgba(22, 81, 148, 1);
            line-height: 48px;
          }
          .text {
            font-size: 18px;
            font-family: PingFang;
            font-weight: bold;
            color: rgba(52, 52, 52, 1);
            // line-height: 48px;
          }
        }
      }
    }
  }
  .serviceHeard {
    height: 64px;
    line-height: 64px;
    padding: 0 10px;
    background: rgba(240, 242, 245, 1);
    font-size: 20px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    box-sizing: border-box;
  }
  .servicebody {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    // height: 80px;
    line-height: 80px;
    span {
      background: rgba(22, 81, 148, 1);
      width: 25%;
      text-align: center;
      font-size: 18px;
      font-family: PingFang;
      // font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-right: 1px solid #ebebeb;
      border-bottom: 1px solid #ebebeb;
      box-sizing: border-box;
    }
  }
  .servicebutton {
    margin: 30px auto 0;
    width: 320px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #6c2c66;
    border-radius: 4px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
